import React, { useEffect, useRef } from "react";
import TopNavigation from "../components/TopNavigation/TopNavigation";
import Footer from "../components/Footer/Footer";
import { animateScroll } from "react-scroll";
import Slider from "../components/Slider/Slider";
import BackToTopButton from "../components/BackToTopButton/BackToTopButton";
import NewsDetails from "../components/NewsDetails/NewsDetails";
// import VideoSlider from "../components/Slider/VideoSlider";

// import LocomotiveScroll from "locomotive-scroll";
//  import "./locomotive.css"; 

const HomePage = () => {

  return (
    <>
    <div>
      <TopNavigation title="Talukder Group" />
      <Slider /> 
      {/* <VideoSlider />  */} 
      {/* <Services /> */} 
      <NewsDetails /> 
      <Footer />
      <BackToTopButton /> 
      </div> 
    </>
  );
};

export default HomePage;
